<template>
    <div>
      <van-nav-bar
        title="联系客服"
        left-text="返回"
        left-arrow
        onclick="window.history.go(-1)"
      />
      <iframe id="external-frame" scrolling="no" marginheight=0 marginwidth=0  frameborder="0" width="100%" :height="heigh" :src="server_url" ></iframe>
    </div>
</template>

<script>
    export default {
      name: "Service",
      data(){
        return{
          heigh:window.innerHeight-100,
          server_url:''
        }
      },
      methods:{
        get_server_url(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "server_url"
              }
            })
            .then(function(res) {
              if (res.data.code == 1) {
                var data = res.data.data;
                that.server_url = data;
              } else if (res.data.code == 0) {
                  that.$toast.fail(res.data.msg);
              }
            });
        }
      },
      mounted: function () {
        let heigh = window.innerHeight;
        this.get_server_url();
      }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Service.vue